import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./notification-card.scss";

const NotificationCard = ({ children, handlerClick, actionText }) => {
  return (
    <div className="notification-card-container">
      <div className="notification-card-content">
        <div className="circle-bell">
          <FontAwesomeIcon icon="bell" color="#FFFFFF" />
        </div>
        <div className="notification-message">{children}</div>
      </div>

      <button
        type="button"
        className="cob-btn btn-primary not-uppercase notification-action"
        onClick={handlerClick}
      >
        {actionText}
      </button>
    </div>
  );
};

NotificationCard.defaultProps = {};
NotificationCard.propTypes = {
  children: PropTypes.node.isRequired,
  handlerClick: PropTypes.func.isRequired,
  actionText: PropTypes.string.isRequired,
};

export default NotificationCard;
